const useLogs = () => {
  const router = useRouter();
  const logs = inject('logs') as AppLogFunction;

  const appRefresh = (hard: boolean = false, method: string = 'BUTTON') => {
    const event = {
      hard,
      method,
    };

    logs({
      topic: 'APP_REFRESH',
      event,
      url: router.currentRoute.value.fullPath,
    });
  };

  const appSectionView = (section: string) => {
    const event = {
      section,
    };

    logs({
      topic: 'APP_SECTION_VIEW',
      event,
      url: router.currentRoute.value.fullPath,
    });
  };

  const appToastReceive = (source?: string) => {
    const event = {
      toast: {
        type: 'TICKET_CONTEXT',
      },
      source,
    };

    logs({
      topic: 'APP_TOAST_RECEIVE',
      event,
    });
  };

  return {
    appRefresh,
    appSectionView,
    appToastReceive,
  };
};

export default useLogs;
